import { Link } from "react-router-dom";
import React from "react";
import { motion } from "framer-motion";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import {useContext} from 'react'
import { defaultLang } from "./LanguageContext";


const Main = () => {

  const {lang} = useContext(defaultLang)
  useEffect(() => {
    Aos.init({
      duration: 500,
    });
  }, []);

  return (
    <header className=' max-h-[100vh] main relative font-bold mt-32  dark:text-[#1E1E1E]  text-[#E3E3E3] leading-[1.5] h-[50vh]  mx-3 md:mx-20 lg:mx-36 xl:mx-48 '>
      <div className='planet'></div>
      <h1 className='main-text' data-aos='fade-right'>
        {
          lang === 'Eng' ? (<>
          Hey,
          <br /> i'm Daniel
          <br />A Web {" "}
          <span className='text-linear'>
            developer <span className='three-dots'>...</span>
          </span> </>) : <>
          Hey,
          <br />sono Daniel
          <br />uno sviluppatore {" "}
          <span className='text-linear'>
            Web <span className='three-dots'>...</span>
          </span>

          </>
        }
      </h1>

      <motion.button
        whileHover={{ scale: 1.07 }}
        whileTap={{ scale: 0.9 }}
        className='btn md:hidden text-[1rem] mt-5'>
        <Link className="flex gap-2" to='/projects'>{lang === 'Eng' ? 'Projects' : 'Progetti'}  <span>
        <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='fill-current mt-1 w-4 h-4 rotate-[26deg] arrow-animate'
                  viewBox='0 0 384 512'>
                  <path d='M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z' />
                </svg></span></Link>
      </motion.button>

      <Link to='/projects' className='absolute hidden md:flex justify-center items-center z-10 rounded-full w-32 h-32 right-0 bg-gradient-to-r to-[#6d4d82] from-[#9494ff] top-0 hoverscale'>
        <div className=' -z-10  bg-gradient-to-r absolute to-[#cea7e9] from-[#9494ff]  w-[300px] h-[300px] rounded-full opacity-10 blur-xl dark:blur-lg'></div>
        <div className='bg-[#242424] flex justify-center items-center rounded-full  w-[7.8rem] h-[7.8rem] z-50 '>
          <p className='text-sm  text-transparent bg-clip-text bg-gradient-to-br to-[#cea7e9] from-[#9494ff] uppercase cursor-pointer font-black flex flex-col'>
            {" "}
            <span className='flex gap-1 text-gray-300 lowercase justify-center'>
              
              {lang === 'Eng' ? 'View' : 'Visualizza'}
              <span>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='fill-white w-4 h-4 rotate-[26deg] arrow-animate'
                  viewBox='0 0 384 512'>
                  <path d='M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z' />
                </svg>
              </span>
            </span>{" "}
            <span className='text-base'>{lang === 'Eng' ? 'Projects' : 'I Progetti'}</span>
          </p>
        </div>
      </Link>
      
    </header>
  );
};

export default Main;
